/* Order via WhatsApp v2 — live cart sync.
   One cart id in the cookie mamatega_order_cart_id. Posts the Shopify
   cart when it changes so https://www.shopmamatega.com/orderid/<id>
   shows the current items. */
(function () {
  var COOKIE = "mamatega_order_cart_id";
  var SIG_KEY = "mamatega_order_cart_sig";
  var ALPH = "23456789abcdefghjkmnpqrstuvwxyz";
  var ID_RE = /^oc[23456789abcdefghjkmnpqrstuvwxyz]{10}$/;
  var api = (window.MAMATEGA_API_BASE || "https://mamatega-api.tail56793.ts.net").replace(/\/$/, "");

  function readCookie() {
    var parts = String(document.cookie || "").split(";");
    for (var i = 0; i < parts.length; i++) {
      var bit = parts[i].trim();
      if (bit.indexOf(COOKIE + "=") === 0) return decodeURIComponent(bit.slice(COOKIE.length + 1));
    }
    return "";
  }

  function writeCookie(id) {
    document.cookie = COOKIE + "=" + encodeURIComponent(id) + "; path=/; max-age=34560000; SameSite=Lax";
    try { localStorage.setItem(COOKIE, id); } catch (e) {}
  }

  function freshId() {
    var id = "oc";
    for (var i = 0; i < 10; i++) id += ALPH.charAt(Math.floor(Math.random() * ALPH.length));
    return id;
  }

  function cartId() {
    var id = readCookie();
    if (!ID_RE.test(id)) {
      try { id = localStorage.getItem(COOKIE) || ""; } catch (e) { id = ""; }
    }
    if (!ID_RE.test(id)) id = freshId();
    writeCookie(id);
    return id;
  }

  function naira(amount) {
    var n = Number(amount);
    if (!isFinite(n) || n <= 0) return "";
    var whole = Math.abs(n - Math.round(n)) < 0.001;
    var num = whole ? String(Math.round(n)) : n.toFixed(2);
    var parts = num.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return "₦" + parts.join(".");
  }

  function variantLabel(item) {
    var bits = [];
    var seen = {};
    function add(value) {
      var text = String(value || "").trim();
      if (!text || text.toLowerCase() === "default title") return;
      var key = text.toLowerCase();
      if (seen[key]) return;
      seen[key] = 1;
      bits.push(text);
    }
    var options = item && item.options_with_values;
    if (Array.isArray(options)) {
      options.forEach(function (opt) { add(opt && opt.value); });
    }
    if (!bits.length && item && Array.isArray(item.variant_options)) {
      item.variant_options.forEach(add);
    }
    String((item && item.variant_title) || "").split(/\s*\/\s*/).forEach(add);
    return bits.join(" · ").slice(0, 160);
  }

  function colorValue(item) {
    var options = item && item.options_with_values;
    if (!Array.isArray(options)) return "";
    for (var i = 0; i < options.length; i++) {
      var name = String(options[i] && options[i].name || "").toLowerCase();
      if (name !== "color" && name !== "colour" && name !== "shade" && name !== "swatch") continue;
      var value = String(options[i].value || "").trim();
      if (value && value.toLowerCase() !== "default title") return value.slice(0, 80);
    }
    return "";
  }

  function lineImage(item) {
    var featured = item && item.featured_image;
    var url = "";
    if (featured && typeof featured === "object") url = featured.url || featured.src || "";
    else if (typeof featured === "string") url = featured;
    if (!url) url = (item && item.image) || "";
    url = String(url || "");
    if (url.indexOf("//") === 0) url = "https:" + url;
    return url;
  }

  function plainDesc(item) {
    return String((item && item.product_description) || "")
      .replace(/<[^>]+>/g, " ")
      .replace(/&nbsp;/gi, " ")
      .replace(/&amp;/g, "&")
      .replace(/&#39;|&apos;/g, "'")
      .replace(/&quot;/g, '"')
      .replace(/\s+/g, " ")
      .trim()
      .slice(0, 320);
  }

  function nairaItems(cart) {
    return ((cart && cart.items) || []).slice(0, 40).map(function (item) {
      var variant = variantLabel(item);
      var color = colorValue(item);
      if (color && variant.toLowerCase().indexOf(color.toLowerCase()) < 0) {
        variant = variant ? color + " · " + variant : color;
      }
      return {
        vendor: String(item.vendor || "").slice(0, 80),
        title: String(item.product_title || item.title || "").slice(0, 160),
        variantTitle: variant.slice(0, 160),
        color: color,
        handle: String(item.handle || ""),
        image: lineImage(item),
        description: plainDesc(item),
        quantity: Number(item.quantity || 1),
        price: Number(item.final_price || item.price || 0) / 100,
        variantId: String(item.variant_id || item.id || "")
      };
    });
  }

  function signature(items) {
    return items.map(function (item) {
      return [item.variantId, item.quantity, item.price, item.title, item.vendor, item.variantTitle, item.color, item.image, String(item.description || "").slice(0, 24)].join("|");
    }).join(";");
  }

  function messageFor(id, items) {
    var lines = ["Hi MamaTega, I'd like to place an order.", ""];
    if (!items.length) {
      lines.push("My cart is open here:");
    } else {
      items.forEach(function (item, index) {
        var title = item.title || "Item";
        if (item.variantTitle) title += " — " + item.variantTitle;
        var bit = (index + 1) + ". " + title + " × " + (item.quantity || 1);
        var price = naira(item.price);
        if (price) bit += " — " + price;
        lines.push(bit);
      });
      lines.push("");
      lines.push("Photos and the live cart:");
    }
    lines.push("https://www.shopmamatega.com/orderid/" + id);
    return lines.join("\n");
  }

  var state = { id: cartId(), url: "", message: "", whatsapp: "", items: [] };
  state.url = "https://www.shopmamatega.com/orderid/" + state.id;
  state.message = messageFor(state.id, []);

  var sawCart = false;
  function rememberLocal(confirmed) {
    if (!sawCart) return;
    if (!(state.items || []).length && !confirmed) {
      try {
        var prev = JSON.parse(localStorage.getItem("mamatega_order_cart_snapshot_v1") || "null");
        if (prev && prev.id === state.id && prev.items && prev.items.length) return;
      } catch (e0) {}
    }
    try {
      localStorage.setItem("mamatega_order_cart_snapshot_v1", JSON.stringify({
        ok: true,
        id: state.id,
        url: state.url,
        items: state.items || []
      }));
    } catch (e) {}
  }

  function apply(data, items) {
    if (data && data.id) state.id = data.id;
    state.items = items || state.items || [];
    state.url = (data && data.url) || ("https://www.shopmamatega.com/orderid/" + state.id);
    state.message = (data && data.message) || messageFor(state.id, state.items);
    state.whatsapp = (data && data.whatsapp) || "";
    writeCookie(state.id);
    rememberLocal(!!(data && data.ok));
  }

  var pending = null;
  var queued = null;
  var dropped = {};
  var lastKnownAt = 0;
  var lastKnownSig = "";

  function markDropped(before, after) {
    var now = Date.now();
    var keep = {};
    after.forEach(function (item) {
      keep[item.variantId] = (keep[item.variantId] || 0) + Number(item.quantity || 0);
    });
    (before || []).forEach(function (item) {
      var id = item && item.variantId;
      if (!id) return;
      if (Number(item.quantity || 0) > (keep[id] || 0)) dropped[id] = now + 4000;
    });
  }

  function isStale(items) {
    var now = Date.now();
    for (var i = 0; i < items.length; i++) {
      var until = dropped[items[i].variantId];
      if (until && until > now) return true;
    }
    return false;
  }

  function readCart() {
    return fetch("/cart.js?mtg=" + Date.now(), {
      credentials: "same-origin",
      cache: "no-store",
      headers: { Accept: "application/json", Pragma: "no-cache" }
    }).then(function (res) {
      if (!res || !res.ok) return null;
      var cached = String(res.headers.get("x-cartjs-cache") || "") === "1";
      return res.json().then(function (cart) {
        if (cart) cart.__mtgCached = cached;
        return cart;
      });
    });
  }

  function publishLocal(items) {
    try {
      document.dispatchEvent(new CustomEvent("mamatega:order-cart-local", {
        detail: { id: state.id, items: items }
      }));
    } catch (e) {}
  }

  function sync(preset) {
    var known = !!(preset && Array.isArray(preset.items));
    if (known) {
      var quick = nairaItems(preset);
      var quickSig = signature(quick);
      lastKnownAt = Date.now();
      lastKnownSig = quickSig;
      var savedSig = "";
      try { savedSig = sessionStorage.getItem(SIG_KEY) || ""; } catch (e) {}
      if (quickSig !== savedSig || (state.items || []).length !== quick.length) publishLocal(quick);
    }
    if (pending) {
      if (known) queued = preset;
      else if (!queued) queued = true;
      return pending;
    }
    var source = known ? Promise.resolve(preset) : readCart();
    pending = source.then(function (cart) {
      if (queued && queued !== true) return state;
      if (!cart || !Array.isArray(cart.items)) return state;
      sawCart = true;
      var items = nairaItems(cart);
      if (!known && isStale(items)) return state;
      if (!known && lastKnownSig && (cart.__mtgCached || Date.now() - lastKnownAt < 15000)) {
        if (signature(items) !== lastKnownSig) return state;
      }
      var sig = signature(items);
      var saved = "";
      try { saved = sessionStorage.getItem(SIG_KEY) || ""; } catch (e) {}
      if (sig === saved && state.id) {
        apply(null, items);
        return state;
      }
      var before = (state.items || []).slice();
      return fetch(api + "/api/order-cart/sync", {
        method: "POST",
        credentials: "omit",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: state.id,
          shopifyToken: cart.token || "",
          items: items
        })
      })
        .then(function (res) { return res && res.ok ? res.json() : null; })
        .then(function (data) {
          if (data && data.ok) {
            markDropped(before, items);
            try { sessionStorage.setItem(SIG_KEY, sig); } catch (e2) {}
            try {
              document.dispatchEvent(new CustomEvent("mamatega:order-cart-local", { detail: data }));
            } catch (e3) {}
          }
          apply(data, items);
          return state;
        });
    }).catch(function () { return state; }).then(function (out) {
      pending = null;
      var next = queued;
      queued = null;
      if (next) return sync(next === true ? undefined : next);
      return out;
    });
    return pending;
  }

  window.MAMATEGA_ORDER_WHATSAPP_V2 = true;
  window.mamategaOrderCartV2 = state;
  window.mamategaOrderCartV2.sync = sync;
  window.mamategaOrderVariantLabel = variantLabel;

  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(function () { sync(); }, 250);
  }
  function afterMutation(cart) {
    if (cart && Array.isArray(cart.items)) sync(cart);
    else schedule();
  }
  var mutation = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  if (window.fetch && !window.fetch.__mtgOrderV2) {
    var orig = window.fetch;
    var hooked = function (input) {
      var pendingFetch = orig.apply(this, arguments);
      try {
        var url = String((input && input.url) || input || "");
        if (mutation.test(url)) {
          pendingFetch.then(function (res) {
            if (!res || !res.clone) return schedule();
            res.clone().json().then(afterMutation).catch(schedule);
          }, function () {});
        }
      } catch (e) {}
      return pendingFetch;
    };
    hooked.__mtgOrderV2 = true;
    window.fetch = hooked;
  }
  try {
    var proto = window.XMLHttpRequest && XMLHttpRequest.prototype;
    if (proto && typeof proto.open === "function" && !proto.open.__mtgOrderV2 && typeof proto.send === "function") {
      var origOpen = proto.open;
      var origSend = proto.send;
      proto.open = function (method, url) {
        try { this.__mtgOrderUrl = String(url || ""); } catch (e) {}
        return origOpen.apply(this, arguments);
      };
      proto.open.__mtgOrderV2 = true;
      proto.send = function () {
        try {
          if (mutation.test(this.__mtgOrderUrl || "")) {
            this.addEventListener("load", function () {
              var cart = null;
              try { cart = JSON.parse(this.responseText); } catch (e2) {}
              afterMutation(cart);
            });
          }
        } catch (e) {}
        return origSend.apply(this, arguments);
      };
    }
  } catch (e) {}
  try {
    if (window.XMLHttpRequest && !window.XMLHttpRequest.__mtgOrderV2) {
      var OriginalXHR = window.XMLHttpRequest;
      var WrappedXHR = function () {
        var xhr = new OriginalXHR();
        var open = xhr.open;
        var url = "";
        if (typeof open === "function") {
          xhr.open = function (method, next) {
            url = String(next || "");
            return open.apply(xhr, arguments);
          };
        }
        xhr.addEventListener("load", function () {
          if (!mutation.test(url)) return;
          var cart = null;
          try { cart = JSON.parse(xhr.responseText); } catch (e2) {}
          afterMutation(cart);
        });
        return xhr;
      };
      WrappedXHR.prototype = OriginalXHR.prototype;
      WrappedXHR.__mtgOrderV2 = true;
      window.XMLHttpRequest = WrappedXHR;
    }
  } catch (e) {}
  function hookJquery() {
    var $ = window.jQuery || window.$;
    if (!$ || !$.fn || hookJquery.done) return;
    hookJquery.done = true;
    $(document).ajaxComplete(function (_event, xhr, settings) {
      var url = String((settings && settings.url) || "");
      if (!mutation.test(url)) return;
      var cart = xhr && (xhr.responseJSON || null);
      if (!cart) {
        try { cart = JSON.parse(xhr.responseText); } catch (e2) {}
      }
      afterMutation(cart);
    });
  }
  hookJquery();
  window.setTimeout(hookJquery, 800);
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (form && mutation.test(String(form.action || ""))) schedule();
  }, true);
  document.addEventListener("cart:updated", function (e) {
    afterMutation(e && e.detail && e.detail.cart);
  });
  document.addEventListener("cart:refresh", schedule);
  schedule();
  window.setInterval(function () { sync(); }, 2000);
})();
